$(function(){

  set_size_jwplayer = function(){
    var box_w = 575
    var box_h = 317
    if($('#home-b').length == 1){
      if($(window).width() > 880 || $(window).width() <= 605){
        box_w = $('#box-video-home').width();
        if(box_w > 575)
          box_w = 575;
        box_h = Math.floor(box_w/1.81);
      }
    }
    return [box_w, box_h];
  }

  var cover_image = '/wp-content/themes/teamartist/images/' + ($('#home-b').length > 0 ? 'copertina-video-2-grigio.jpg' : 'copertina-video.jpg');

  if($('#video-home').length > 0 && jwplayer('video-home') !== null){
    sizes = set_size_jwplayer();
    var jwplayer_width = sizes[0];
    var jwplayer_height = sizes[1];
    jwplayer('video-home').setup({
      'id': 'player-home',
      'image': cover_image,
      'height': jwplayer_height,
      'width': jwplayer_width,
      'file': 'pgVxYv-QWIg',
      'provider': 'youtube',
      'controlbar': false,
      'modes': [
        { type: 'flash', src: '/wp-content/themes/teamartist/swf/player.swf' },
        { type: 'html5' },
        { type: 'download' }
      ],
      plugins: {
        'hd-1': {}
      }
    });

    var countPlay = 0;
    jwplayer('video-home').onPlay(function(){
      if(countPlay===0){
        _gaq.push(['_trackEvent', 'Video', 'Play', '0']);
        countPlay++;
      }
      else {
        _gaq.push(['_trackEvent', 'Video', 'Re-Play', '0']);
      }
    });

    jwplayer('video-home').onPause(function(){
      var currentTimeVideo = jwplayer().getPosition();
      _gaq.push(['_trackEvent', 'Video', 'Pause', currentTimeVideo+' secondi', '0']);
    });

    var completeVideo = 0;
    jwplayer('video-home').onComplete(function(){
      completeVideo = 1;
      _gaq.push(['_trackEvent', 'Video', 'Completato', '0']);
    });

    window.onbeforeunload = function() {
      var currentTimeVideo = jwplayer().getPosition();
      if(currentTimeVideo > 0 && completeVideo === 0){
        _gaq.push(['_trackEvent', 'Video', 'Interrotto', currentTimeVideo+' secondi']);
      }
    };
  }
});